import { getZrmListingInfo, getZrmUserInfo } from '@zg-rentals/clickstream';
import { _nextTrackEvent } from '../index';

import type { ZrmClickstreamListing, ZrmClickstreamUser } from '@zg-rentals/clickstream';

export const EVENT_IDS = {
  SPECIAL_OFFERS_ADD_NEW: '4448',
  SPECIAL_OFFERS_LEARN_MORE: '4449',
} as const;

type SpecialOffersEventProps = {
  currentProperty: ZrmClickstreamListing;
  user: ZrmClickstreamUser;
  triggerLocation?: string;
};

// https://dataportal.zillowgroup.net/event-registry/4448
export const emitSpecialOffersAddNewEvent = ({
  currentProperty,
  user,
  triggerLocation = 'posting_path',
}: SpecialOffersEventProps) =>
  _nextTrackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.SPECIAL_OFFERS_ADD_NEW,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: triggerLocation,
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'add_offer',
    },
    semantic: {
      semantic_event_nm: 'add_special_offer',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/4449
export const emitSpecialOffersLearnMoreEvent = ({
  currentProperty,
  user,
  triggerLocation = 'posting_path',
}: SpecialOffersEventProps) =>
  _nextTrackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.SPECIAL_OFFERS_LEARN_MORE,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: triggerLocation,
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'learn_more',
    },
    semantic: {
      semantic_event_nm: 'learn_more_special_offer',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });
